import { createMessageService } from './MessageService.impl';

export const myMessageService = createMessageService();
